import { Box, Button, Popover, Typography } from '@mui/material';
import { useCallback } from 'react';
import { TableInstance } from 'react-table';

type FilterPageProps<T extends object> = {
    instance: TableInstance<T>;
    anchorEl: Element | null;
    onClose: () => void;
    show: boolean;
};

export default function FilterPage<T extends object>({ instance, anchorEl, onClose, show }: FilterPageProps<T>) {
    const { allColumns, setAllFilters } = instance;

    const resetFilters = useCallback(() => {
        setAllFilters([]);
    }, [setAllFilters]);

    return (
        <div>
            <Popover
                onClose={onClose}
                anchorEl={anchorEl}
                open={show}
                id={'popover-filters'}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box padding={3}>
                    <Typography sx={{ textTransform: 'uppercase', fontWeight: 300, padding: '0 24px 24px 0' }}>
                        Filters
                    </Typography>
                    <form>
                        <Button
                            color='primary'
                            sx={{
                                position: 'absolute',
                                top: 18,
                                right: 21,
                            }}
                            onClick={resetFilters}
                        >
                            Reset
                        </Button>

                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, 218px)',
                                '@media (max-width: 600px)': {
                                    gridTemplateColumns: 'repeat(1, 180px)',
                                },
                                gap: 3,
                            }}
                        >
                            {allColumns
                                .filter(it => it.canFilter)
                                .map(column => (
                                    <Box key={column.id} width='100%' display='inline-flex' flexDirection='column'>
                                        {column.render('Filter')}
                                    </Box>
                                ))}
                        </Box>
                    </form>
                </Box>
            </Popover>
        </div>
    );
}
